import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { EventoDto, EventoServiceProxy, UpdateEventoDto } from "@shared/service-proxies/service-proxies";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-evento',
  templateUrl: './edit-evento.component.html',
  styleUrls: ['./edit-evento.component.scss']
})
export class EditEventoComponent extends AppComponentBase implements OnInit {
  protected saving: boolean = false;
  protected evento: UpdateEventoDto = new UpdateEventoDto;
  protected data: string;
  protected horaInicio: string;
  protected horaFim: string;
  protected id: string;
  protected ehDiaTodo: boolean = false;
  public horaInicioAgenda: string;
  public horaFimAgenda: string;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private _eventoService: EventoServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  ngOnInit(): void {
    this.getEvento(this.id);
  }

  public save(): void {
    const inicio = this.combinarDataHora(this.data, this.horaInicio);
    const fim = this.combinarDataHora(this.data, this.horaFim);

    if (!inicio || !fim) {
      this.message.warn('Preencha corretamente a data e os horários.');
      return;
    }

    if (!fim.isAfter(inicio)) {
      this.message.warn('O horário final deve ser maior que o horário inicial.');
      return;
    }

    this.saving = true;
    abp.ui.setBusy();

    this.evento.inicio = inicio;
    this.evento.fim = fim;


    this._eventoService.update(this.evento)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
          this.saving = false;
        })
      )
      .subscribe(() => {
        this.onSave.emit();
        this.bsModalRef.hide();
      })
  }

  delete(): void {
    this.saving = true;
    abp.ui.setBusy();

    this._eventoService
      .delete(this.evento.id)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
          this.saving = false;
        })
      )
      .subscribe(() => {
        this.onSave.emit();
        this.bsModalRef.hide();
      })
  }

  private getEvento(id: string): void {
    abp.ui.setBusy();
    this._eventoService.get(id)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((result: EventoDto) => {
        this.evento = Object.assign(new UpdateEventoDto(), result);

        const inicio = moment(result.inicio);
        const fim = moment(result.fim);

        this.data = inicio.format('YYYY-MM-DD');
        this.horaInicio = inicio.format('HH:mm');
        this.horaFim = fim.format('HH:mm');

        if(this.horaInicio == this.horaInicioAgenda && this.horaFim == this.horaFimAgenda){
          this.ehDiaTodo = true;
        }
      });
  }

  private combinarDataHora(data: string, hora: string): moment.Moment | null {
    if (!data || !hora) return null;

    const dataHoraStr = `${data} ${hora}`;

    return moment.utc(dataHoraStr, 'YYYY-MM-DD HH:mm');
  }

  protected checkDiaTodo(): void {
    if (this.ehDiaTodo) {
      this.horaInicio = this.horaInicioAgenda
      this.horaFim = this.horaFimAgenda;
    } else {
      this.horaInicio = this.evento.inicio.format('HH:mm');
      this.horaFim = this.evento.fim.format('HH:mm');
    }
  }
}
